import script from "./SearchResultCard.vue?vue&type=script&setup=true&lang=js"
export * from "./SearchResultCard.vue?vue&type=script&setup=true&lang=js"

import "./SearchResultCard.vue?vue&type=style&index=0&id=6400a933&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6400a933"]])

export default __exports__